import moment from 'moment';
import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Badge } from 'react-bootstrap';
import { getLoadQueueCount } from '../../actions/load';
import { API_DATETIME_FORMAT, PLANTING_PLAN_TYPE_ID } from '../../constants';
import { isPlannedOrTodate, isToday } from '../../helpers/common';
import HarvesterLoadQueue from './Harvester/LoadQueue';
import PlanterLoadQueue from './Planter/LoadQueue';
import '../../../assets/scss/load-queue.scss';
import { LoadQueueProvider } from './Harvester/context/LoadQueueContext';
import { LoadQueueProvider as PlanterLoadQueueProvider } from './Planter/context/LoadQueueContext';

export const LoadQueueIcon = ({ show, handleShow, loadCount }) => {
	return (
		<div
			className={`load-queue-count ${show ? "active" : ""}`}
			onClick={() => (typeof handleShow === 'function') && handleShow(!show)}
			title="Load Queue">
			<div className="btn-load-queue-icon">
				<i className="fa fa-truck" />
			</div>
			<span>
				<Badge
					variant="warning"
					className="badge-load-count">
					{loadCount}
				</Badge>
			</span>
		</div>
	);
};

const LoadQueueCount = props => {
	const dispatch = useDispatch();
	const [show, setShow] = useState(false);
	const { farmId } = props;
	const planTypeId = useSelector(state => state.plan.selectedPlanType);
	const farmConfig = useSelector(state => state.farm.farmSettings.farm_config);
	const loadCount = useSelector(state => state.load.loadQueueCount);
	const timezone = useSelector(state => state.farm.currentFarm.timezone_identifier);
	const { rangeId, range, custom } = useSelector(state => state.analyze.searchParams);
	const roleId = useSelector(state => state.auth.userInfo.role_id);

	const { is_planter_allocation = {} } = farmConfig || {};
	const isPlanterAllocation = (is_planter_allocation && is_planter_allocation.visible);

	let timerId = null;
	const recentHours = useMemo(() => {
		let updatedHours;
		if (farmConfig) {
			updatedHours = farmConfig && farmConfig.load_queue_recent_hours &&
				// farmConfig.load_queue_recent_hours.visible && 
				farmConfig.load_queue_recent_hours.recent_hours ?
				farmConfig.load_queue_recent_hours.recent_hours : 0;
			return updatedHours;
		}
	}, [farmConfig]);

	useEffect(() => {
		clearTimer();
		if (!show) {
			getLoadCount();
			timerId = setInterval(getLoadCount, 2 * 60 * 1000);
		}
		return clearTimer;
	}, [farmId, rangeId, show, recentHours]);

	useEffect(() => {
		if (planTypeId) getLoadCount();
	}, [planTypeId, recentHours])

	const getLoadCount = () => {
		let from = null, to = null;
		if (!isPlannedOrTodate(range)) {
			if (custom.from && custom.to) {
				from = isToday(range) ? moment.utc(custom.from).subtract(recentHours, "hours").format(API_DATETIME_FORMAT) :
					moment.utc(custom.from).format(API_DATETIME_FORMAT);
				to = moment.utc(custom.to).format(API_DATETIME_FORMAT);
			} else {
				const now = moment.utc().tz(timezone);
				from = now.clone().startOf("day").format(API_DATETIME_FORMAT);
				to = now.clone().endOf("day").format(API_DATETIME_FORMAT);
			}
		}

		let loadParams = {
			farmId,
			rangeType: range,
			...!isPlannedOrTodate(range) && { fromDate: from, toDate: to },
			is_current_customer_load: [9].includes(roleId),
			planTypeId
		};
		if (planTypeId && planTypeId === PLANTING_PLAN_TYPE_ID) {
			loadParams['is_planter_allocation'] = isPlanterAllocation;
		}
		dispatch(getLoadQueueCount(loadParams));
	};


	const clearTimer = () => {
		if (timerId) clearInterval(timerId);
		timerId = null;
	};

	useEffect(() => {
		if ([9].includes(roleId)) setShow(true);
	}, [roleId])

	return <>
		<LoadQueueIcon show={show} handleShow={setShow} loadCount={loadCount} />
		{show && (planTypeId === 2 ?
			<PlanterLoadQueueProvider>
				<PlanterLoadQueue
					farmId={farmId}
					onHide={() => setShow(false)}
				/>
			</PlanterLoadQueueProvider> :
			<LoadQueueProvider>
				<HarvesterLoadQueue
					farmId={farmId}
					onHide={() => setShow(false)}
				/>
			</LoadQueueProvider>
		)}
	</>;
};

export default LoadQueueCount;